import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppDispatch } from '../hooks/redux'
import { loginWithLine } from '../store/slices/authSlice'

const LineCallback = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const hasProcessed = useRef(false)
  const [isProcessing, setIsProcessing] = useState(false)

  useEffect(() => {
    // 防止重複執行
    if (hasProcessed.current || isProcessing) {
      console.log('LINE Callback: Already processed or processing, skipping')
      return
    }
    
    hasProcessed.current = true
    setIsProcessing(true)

    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const error = searchParams.get('error')

    console.log('LINE Callback processing:', { 
      code: code ? `${code.substring(0, 10)}...` : null, 
      error, 
      state,
      hasProcessed: hasProcessed.current,
      isProcessing 
    })

    if (error) {
      console.error('LINE OAuth error:', error)
      navigate('/login?error=' + encodeURIComponent('LINE 登入失敗'))
      return
    }

    if (code) {
      // 使用 code 進行 LINE 登入
      dispatch(loginWithLine({ code }))
        .unwrap()
        .then(() => {
          // 登入成功，重新導向到原本要去的頁面或首頁
          const redirectTo = state ? decodeURIComponent(state) : '/'
          console.log('LINE login successful, redirecting to:', redirectTo)
          navigate(redirectTo, { replace: true })
        })
        .catch((error) => {
          console.error('LINE login failed:', error)
          
          // 如果錯誤是因為重複請求導致的，檢查是否已經登入成功
          if (error.response?.status === 400 && 
              (error.response?.data?.message === '授權碼已使用' || 
               error.response?.data?.details === 'invalid authorization code')) {
            // 可能是重複請求，檢查當前認證狀態
            const token = localStorage.getItem('auth_token')
            if (token) {
              console.log('Token exists despite error, continuing with redirect')
              const redirectTo = state ? decodeURIComponent(state) : '/'
              navigate(redirectTo, { replace: true })
              return
            }
          }
          
          // 其他錯誤才導向登入頁面
          navigate('/login?error=' + encodeURIComponent('LINE 登入失敗'))
        })
        .finally(() => {
          setIsProcessing(false)
        })
    } else {
      // 沒有 code，重新導向到登入頁面
      navigate('/login?error=' + encodeURIComponent('LINE 登入失敗'))
      setIsProcessing(false)
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">正在處理 LINE 登入...</p>
      </div>
    </div>
  )
}

export default LineCallback